// Reports count calendar days in the newsroom's timezone, matching the
// backend's REPORT_TIMEZONE, so "today" and the chart labels agree with the
// server no matter where the admin's browser is.
const REPORT_TIMEZONE = "Asia/Beirut";

export default REPORT_TIMEZONE;
